// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 768px) {
  ::ng-deep .modal-dialog.u2026_netpromoterscore-modal {
    max-width: 750px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/U2026_netpromoterscore/U2026_netpromoterscore-modal/U2026_netpromoterscore-modal.component.scss"],"names":[],"mappings":"AAGA;EACI;IACI,gBAAA;EAFN;AACF","sourcesContent":["@import \"../../U2000_style/U2000_style-mixins\";\n@import \"../../U2000_style/U2000_style-variables\";\n\n@media (min-width: $screen-sm-bottom) {\n    ::ng-deep .modal-dialog.u2026_netpromoterscore-modal {\n        max-width: 750px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
